import { render, staticRenderFns } from "./UserPromocodeStats.vue?vue&type=template&id=170c80fb&scoped=true&"
import script from "./UserPromocodeStats.vue?vue&type=script&lang=js&"
export * from "./UserPromocodeStats.vue?vue&type=script&lang=js&"
import style0 from "./UserPromocodeStats.vue?vue&type=style&index=0&id=170c80fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c80fb",
  null
  
)

export default component.exports